import { anonReferAFriend, searchRecruiters , getUtmTrackerId } from '../../../../lib/helpers/jobHelpers';
import { logWLAnalyticsEvent } from '../../../../lib/helpers/wlAnalyticsLoggerUtil';

export default () => {
  apos.util.widgetPlayers.referFriend = {
    selector: "#refer-friend",
    player: async function (referFriend) {
      if (referFriend) {
        const phoneNumberField = referFriend.querySelector('#friend_phoneNumber');
         const myPhoneNumberField = referFriend.querySelector('#referrerDetail_phoneNumber');
        const companyData = referFriend.querySelector('#refer-friend-data').dataset;
        const config = {
          initialCountry: companyData?.phonedefaultcountry || 'us',
        }
        if (companyData.countrycodephonenumber) {
          const countries = JSON.parse(
            companyData.countrycodephonenumber
          ).map(c => c.toLowerCase())
          if (countries.length > 0) {
            config.onlyCountries = countries
          }
        } 
        var friendPhoneInput = window.intlTelInput(phoneNumberField,config);
        var myPhoneInput = window.intlTelInput(myPhoneNumberField, config);
        const __t = JSON.parse(referFriend.dataset.localizedValues);
        const submitForm = referFriend.querySelector('#refer-friend-submit');
        const emailField = referFriend.querySelector('#friend_email');
        const myEmailField = referFriend.querySelector('#referrerDetail_email');
        const commentsField = referFriend.querySelector('#friend_comments');
        const commentsLength = referFriend.querySelector('#friend_commentsLength');
        const resumeField = referFriend.querySelector('#friend_resumeFile');
        const resumeLabel = referFriend.querySelector('#friend_resumeLabel');
        const recruiterInfo = document.querySelector('#recruiter-info-container');
        const resumesubmitinMYR = recruiterInfo?.dataset.enableCandidateSignup=== 'true';
        const containsUtmParams = window.location.search.includes('utm_source') || window.sessionStorage.getItem('utm_source');
        if(containsUtmParams && !resumesubmitinMYR) {
          getUtmTrackerId('Job')
            .then(response => {
              window.sessionStorage.setItem('utmTrackerId',response);
            });
        }
        emailField.addEventListener('keydown', () => {emailField.setCustomValidity('')});
        phoneNumberField.addEventListener('keydown', () => {phoneNumberField.setCustomValidity('')});
        myEmailField.addEventListener('keydown', () => {myEmailField.setCustomValidity('')});
        myPhoneNumberField.addEventListener('keydown', () => {myPhoneNumberField.setCustomValidity('')});
        commentsField.addEventListener('keydown', () => {commentsLength.textContent  = commentsField.value.length + '/1000'});
        resumeField.addEventListener('change', () => {
          if (resumeField.files.length > 0) {
            resumeLabel.innerHTML = `<span>${resumeField.files[0].name}</span>`;
          }
        });              
        if(submitForm) {
          const recruiterSearch = referFriend.querySelector('#recruiter-filters-collapse');

          if(recruiterSearch) {
            const inputField = recruiterSearch.querySelector('input[type=text]');

            inputField.addEventListener('keyup', async () => {
              const recruiterSearch = referFriend.querySelector('#recruiter-filters-collapse');
              const inputField = recruiterSearch.querySelector('input[type=text]');
              const selectField = recruiterSearch.querySelector('select');
              const filterSlugAlias = selectField.getAttribute('data-filterslugalias');
              const filterName = selectField.getAttribute('data-filtername');
              const fieldType = selectField.getAttribute('data-fieldtype');
              const displayType = selectField.getAttribute('data-displaytype');
              if(inputField.value && inputField.value.length >= 3) {
                const recruiters = await searchRecruiters(inputField.value);
                if(recruiters && recruiters.recruiterList) {
                  const values = recruiters.recruiterList.map((x) => {
                    return {display: x.recruiterName, value: x.recruiterEmail, extraValue: x.recruiterId}
                  });
                  addDropDown(recruiterSearch.parentNode, inputField, values, filterSlugAlias, filterName, fieldType, displayType, selectField);
                }
                else
                  addDropDown(recruiterSearch.parentNode, inputField, [], filterSlugAlias, filterName, fieldType, displayType, selectField);
              }
            });
          }

          submitForm.addEventListener('click', async () => {
            var friendPhone = '', myPhone = '';
            var friendResumeFile = null;

            var overlay = document.querySelector("#refer-friend-overlay");
            var spinner = document.querySelector('#refer-friend-spinner');
            try {
              const firstNameField = referFriend.querySelector('#friend_firstName');
              const lastNameField = referFriend.querySelector('#friend_lastName');
              const emailField = referFriend.querySelector('#friend_email');
              const phoneNumberField = referFriend.querySelector('#friend_phoneNumber');
              const commentsField = referFriend.querySelector('#friend_comments');
              const resumeField = referFriend.querySelector('#friend_resumeFile');

              const myFirstNameField = referFriend.querySelector('#referrerDetail_firstName');
              const myLastNameField = referFriend.querySelector('#referrerDetail_lastName');
              const myEmailField = referFriend.querySelector('#referrerDetail_email');
              const myPhoneNumberField = referFriend.querySelector('#referrerDetail_phoneNumber');
              const termsField = referFriend.querySelector('#terms');
              const termsField2 = referFriend.querySelector('#terms2');

              const recruiterEmail = referFriend.querySelector('#recruiterEmail');
              const recruiterEmailfromRaf = recruiterInfo?.dataset.recruiterEmail;
              const isMeetYouRecruiterPage = window.location.pathname.includes('/profiles');
              friendPhone = friendPhoneInput.getNumber();
              myPhone = myPhoneInput.getNumber();

              if (resumeField.files.length > 0) {
                friendResumeFile = resumeField.files[0];
              }

              const isValidated =
                validateUserFields(myFirstNameField, myLastNameField, myEmailField, myPhoneNumberField, myPhoneInput, termsField,termsField2) &&
                validateUserFields(firstNameField, lastNameField, emailField, phoneNumberField, friendPhoneInput) &&
                validateResume(resumeField);

              if (isValidated) {

                if(myEmailField.value.trim() === emailField.value.trim()) {
                  displayValidationMessage(emailField, __t['referAFriend.emailRepeatedError']);
                  return;
                } else if(myPhone.trim() === friendPhone.trim()) {
                  displayValidationMessage(phoneNumberField, __t['referAFriend.phoneNumberRepeatedError']);
                  return;
                }
                const referrerDetail = {
                  email: myEmailField.value,
                  firstName: myFirstNameField.value,
                  lastName: myLastNameField.value,
                  phoneNumber: myPhone,
                };
                const referredFriend = {
                  email: emailField.value,
                  firstName: firstNameField.value,
                  lastName: lastNameField.value,
                  phoneNumber: friendPhone,
                  additionalNote: commentsField.value
                };
                const formData = new FormData();
              let utmTrackerId = window.sessionStorage.getItem('utmTrackerId');
               if (utmTrackerId) {
                 formData.append('utmTrackerId', utmTrackerId);
                }
             
                formData.append('referrerDetail', JSON.stringify(referrerDetail));
                formData.append('friendList', JSON.stringify([referredFriend]));
                if (recruiterEmail?.value) {
                  formData.append('recruiterEmail', recruiterEmail.value);
                }
                if(recruiterEmailfromRaf){
                  formData.append('recruiterEmail', recruiterEmailfromRaf);
                }

                if (friendResumeFile != null) {
                  formData.append('resumeFile', friendResumeFile);
                }
          
              if(isMeetYouRecruiterPage){
                formData.append('originType', "08");
              }
                formData.append('userAgent',"WL-CMS")


                overlay.style.display = 'block';
                spinner.style.display = 'block';

                var response = await anonReferAFriend(formData);

                overlay.style.display = 'none';
                spinner.style.display = 'none';
                if (response.success == true) {
                  referFriend.querySelector('#resume-form').remove();
                  referFriend.querySelector('#refer-friend-post-submit').style.display = 'block';
                  const sucessMsg =   referFriend.querySelector('#refer-friend-post-submit');
                  if (sucessMsg && isMeetYouRecruiterPage) {
                    sucessMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }
                  mailClientOpener(response, emailField.value);
                  // Track Friend Referred Event (GDPR Compliance - Removed individual's personal data)
                  logWLAnalyticsEvent(`Friend Referred`, {
                    recruiterId: recruiterEmail.getAttribute('data-extraValue'),
                    referralType: 'Friend referral',
                    //comments: commentsField.value,
                    loggedIn: false,
                  });                  
                }
                else if (response.errorMessage) {
                  const friendFullName = `${firstNameField.value} ${lastNameField.value}`.trim();
                  displayValidationMessage(emailField, __t['referAFriend.referrerAlreadyWorkingError'].replace('{{friendFullName}}', friendFullName));
                }
              }
            } catch (err) {
              console.log('Error:', err);
              overlay.style.display = 'none';
              spinner.style.display = 'none';
            }
            return false;
          });
        }

        function validateUserFields(firstName, lastName, emailField, phoneField, phoneInput, termsField,termsField2) {

          firstName.setCustomValidity('');
          lastName.setCustomValidity('');
          emailField.setCustomValidity('');
          phoneField.setCustomValidity('');

          if (!(firstName.value.length > 0)) {
            displayValidationMessage(firstName, __t['referAFriend.firstNameRequired']);
            return false;
          }

          if (lastName.value.length < 3) {
            const message = lastName.value.length === 0
              ? __t['referAFriend.lastNameRequired']
              : __t['referAFriend.lastNameMinLengthError'];

            displayValidationMessage(lastName, message);
            return false;
          }

          if (emailField.value.length == 0 || !validateEmail(emailField.value)) {
            displayValidationMessage(emailField, emailField.value.length ? __t['global.emailErrorInvalid'] : __t['global.emailErrorRequired']);
            return false;
          }

          if (!(phoneField.value.length > 0 && phoneInput.isValidNumber())) {
            displayValidationMessage(phoneField, phoneField.value.length ? __t['quickApply.phoneErrorInvalid'] : __t['quickApply.phoneErrorRequired']);
            return false;
          }

          if (companyData['termsandservices'] == "true" && termsField) {
            termsField.setCustomValidity('');
            if (!termsField.checked) {
              displayValidationMessage(termsField, __t['quickApply.termsRequired']);
              return false;
            }
            if (termsField2 && !termsField2.checked) { 
              displayValidationMessage(termsField2, __t['quickApply.termsRequired']);
              return false;
            }
          }

          return true;
        };

        function validateResume(resumeField) {
          const MAX_SIZE = 2097152;
          resumeField.setCustomValidity('');

          var allowedTypes = companyData['resumetypesallowed'].split(",");

          if (resumeField.files.length > 0) {
            const file = resumeField.files[0];
            if (!allowedTypes.includes(file.type)) {
              displayValidationMessage(resumeField, __t['quickApply.resumeErrorInvalid']);
              return false;
            } else if (file.size > MAX_SIZE) {
              displayValidationMessage(resumeField, __t['referAFriend.fileSizeError']);
              return false;
            }
          }

          return true;
        };



        function validateEmail(email) {
          return String(email)
            .toLowerCase()
            .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        };

        function formatPhoneNumber(value, country) {
          let digits = value.replace(/\D/g, "");
          const maxLength = getMaxLength(country);
          digits = digits.slice(0, maxLength);
          const formatter = new libphonenumber.AsYouType(country);
          return formatter.input(digits);          
        }
        
        function getMaxLength(country) {
          const metadata = new libphonenumber.Metadata();
          metadata.selectNumberingPlan(country);
          const possibleLengths = metadata.numberingPlan.possibleLengths();
          return Math.max(...possibleLengths);
        }


        function reformatMyPhone() {
          const selected = myPhoneInput.getSelectedCountry()?.iso2?.toUpperCase();
          const fallback = companyData.phonedefaultcountry?.toUpperCase();
          const country = selected || fallback;
          let digits = myPhoneNumberField.value.replace(/\D/g, "");    
          digits = digits.substring(0, getMaxLength(country));
          const formatter = new libphonenumber.AsYouType(country);
          myPhoneNumberField.value = formatter.input(digits);
        }

         function reformatPhone() {
          const selected = friendPhoneInput.getSelectedCountry()?.iso2?.toUpperCase();
          const fallback = companyData.phonedefaultcountry?.toUpperCase();
          const country = selected || fallback;
          let digits = phoneNumberField.value.replace(/\D/g, "");    
          digits = digits.substring(0, getMaxLength(country));
          const formatter = new libphonenumber.AsYouType(country);
          phoneNumberField.value = formatter.input(digits);
        }

        phoneNumberField.addEventListener("input", reformatPhone);
        phoneNumberField.addEventListener("countrychange", reformatPhone);

        myPhoneNumberField.addEventListener("input", reformatMyPhone);
        myPhoneNumberField.addEventListener("countrychange", reformatMyPhone);

        function displayValidationMessage(field, message) {
          try {
            field.focus();
            setTimeout(() => {
              field.setCustomValidity(message || __t['global.requiredField']);
              field.reportValidity();
             }, 700);
          } catch (err) {
            console.log(err);
          }
        };


        function addDropDown(parent, input, arr, filterSlugAlias, filterName, fieldType, displayType, selectField) {

          var dropDown = parent.querySelector(`#${input.id}-dropdown-list`);
          if(dropDown) dropDown.remove();

          dropDown = document.createElement('DIV');
          dropDown.setAttribute('id', `${input.id}-dropdown-list`);
          dropDown.setAttribute('class', 'dropdown-fields');
          input.parentNode.appendChild(dropDown);

          const value = input.value;

          for (let i = 0; i < arr.length; i++) {
            const option = document.createElement('option');
            option.setAttribute('value', arr[i].value);
            option.setAttribute('text', arr[i].display);
            selectField.appendChild(option);
            if (value) {
              if (arr[i].display.toUpperCase().includes(value.toUpperCase())) {
                const dropDownField = addDropDownField(arr[i].display, arr[i].value, filterSlugAlias, filterName, fieldType, displayType, selectField, arr[i].extraValue);
                dropDown.appendChild(dropDownField);
              }
            } else {
              const dropDownField = addDropDownField(arr[i].display, arr[i].value, filterSlugAlias, filterName, fieldType, displayType, selectField, arr[i].extraValue);
              dropDown.appendChild(dropDownField);
            }
          }

          input.addEventListener('focusout', () => {
            setTimeout(() => {closeDropDown(dropDown); }, 500);
          });
          input.addEventListener('focus', () => {
            addActive(dropDown);
          });

          addActive(dropDown);

          function addDropDownField(display, value, filterSlugAlias, filterName, fieldType, displayType, selectField, extraValue) {
            const field = document.createElement('DIV');
            field.innerHTML = display;
            field.innerHTML += `<input type="hidden" value="${display}">`;
            field.innerHTML += `<input type="hidden" value="${value}">`;
            if(extraValue)field.innerHTML += `<input type="hidden" value="${extraValue}">`;

            field.addEventListener('click', function (e) {
              const display = this.getElementsByTagName('input')[0].value;
              const value = this.getElementsByTagName('input')[1].value;
              const extraValue = this.getElementsByTagName('input')[2]?.value;
              input.value = display;
              selectField.value = value;
              selectField.setAttribute('data-extraValue', extraValue);

              var dropDown = parent.querySelector(`#${input.id}-dropdown-list`);

              const type = (displayType == 'multi-select') ? 'checkbox' : 'radio';
              var selectedFields=null

              closeDropDown(dropDown);

              selectedFields = parent.querySelector('.filters__advanced__list__filter__applied');


              if(selectedFields) {
                if (type == 'radio') selectedFields.innerHTML = display;

                selectedFields.innerHTML +=
                  `<div class="filters__advanced__list__filter__applied__value multi-select__${filterName}__${value}" data-filterdata="${filterName}__${value}">
                    <input type="${type}" class="btn-check" id="${filterName}__${value}" name="${filterSlugAlias}" value="${display}" data-filtername="${filterName}" data-fieldtype="${fieldType}" data-displaytype="${displayType}" checked>
                    <label class="btn btn-outline-primary custom" for="${filterName}__${value}">${display}<svg width="12" height="12" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.05752 5.49999L9.28251 2.28249C9.42374 2.14126 9.50308 1.94971 9.50308 1.74999C9.50308 1.55026 9.42374 1.35871 9.28251 1.21749C9.14129 1.07626 8.94974 0.996918 8.75002 0.996918C8.55029 0.996918 8.35874 1.07626 8.21752 1.21749L5.00002 4.44249L1.78252 1.21749C1.64129 1.07626 1.44974 0.996918 1.25002 0.996918C1.05029 0.996918 0.858743 1.07626 0.717515 1.21749C0.576287 1.35871 0.496946 1.55026 0.496946 1.74999C0.496946 1.94971 0.576287 2.14126 0.717515 2.28249L3.94252 5.49999L0.717515 8.71749C0.647219 8.78721 0.591423 8.87016 0.553347 8.96155C0.51527 9.05295 0.495667 9.15098 0.495667 9.24999C0.495667 9.349 0.51527 9.44703 0.553347 9.53842C0.591423 9.62981 0.647219 9.71276 0.717515 9.78249C0.787237 9.85278 0.870188 9.90858 0.961583 9.94666C1.05298 9.98473 1.15101 10.0043 1.25002 10.0043C1.34902 10.0043 1.44705 9.98473 1.53845 9.94666C1.62984 9.90858 1.71279 9.85278 1.78252 9.78249L5.00002 6.55749L8.21752 9.78249C8.28724 9.85278 8.37019 9.90858 8.46158 9.94666C8.55298 9.98473 8.65101 10.0043 8.75002 10.0043C8.84902 10.0043 8.94705 9.98473 9.03845 9.94666C9.12984 9.90858 9.21279 9.85278 9.28251 9.78249C9.35281 9.71276 9.40861 9.62981 9.44668 9.53842C9.48476 9.44703 9.50436 9.349 9.50436 9.24999C9.50436 9.15098 9.48476 9.05295 9.44668 8.96155C9.40861 8.87016 9.35281 8.78721 9.28251 8.71749L6.05752 5.49999Z" fill="#333C59"></path>
                  </svg></label>
                </div>`;
              } else {
              	// Added search field for theme2 filters
                selectedFields = document.getElementById(`${filterName}__${value}`);
                if(selectedFields) selectedFields.checked = true;
              }
            });
            return field;
          }


          function addActive(dropDown) {
            if (!dropDown) return false;
            dropDown.classList.add('dropdown-active');
          }

          function closeDropDown(dropDown) {
            if (!dropDown) return false;
            dropDown.classList.remove('dropdown-active');
          }
        };
        function mailClientOpener(referralResponse, friendEmail) {
          let messageBody = "";
          const {
            referralDetail : { eventName: subject, referralMessages},
          } = referralResponse;
          let referralMessagesArr = referralMessages.filter(msg => msg.type === "01");
          if(referralMessagesArr && referralMessagesArr.length > 0) {
            let body = referralMessagesArr[0].messageBody.replace(/<br\s*\/?>/g, '\r\n');
            messageBody = encodeURIComponent(body);
          }
          window.location.href = `mailto:${friendEmail}?subject=${encodeURIComponent(subject)}&body=${messageBody}`;
        }
      }
    },
  };
};
